import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import styled from "styled-components";
import { theme } from "twin.macro";
import Loading from "./Loading";
import SwiperCore, { Navigation, Pagination, A11y, Lazy } from 'swiper';
// eslint-disable-next-line import/no-webpack-loader-syntax

SwiperCore.use([Navigation, Pagination, A11y, Lazy]);

const Wrapper = styled.div`
  --swiper-navigation-color: ${theme`colors.blue.500`};
  --swiper-pagination-color: ${theme`colors.blue.500`};

  .swiper-container {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background-color: ${theme`colors.gray.100`};
  }

  .swiper-slide img {
    border: none;
    object-fit: cover;
    width: 100%;
    height: 100%;

    &:not([src]) {
      visibility: hidden;
    }
  }

  .swiper-lazy-preloader {
    border: none;
    animation: none;
  }
`;

const ImageCarousel = ({ images, className, style, ...rest }) => {
  const renderedImages = images.map((img, index) => {
    const { src, alt, objectFit = "contain" } = img;
    return (
      <SwiperSlide key={index}>
        <img 
          data-src={src}
          className="swiper-lazy"
          alt={alt}
          style={{
            objectFit,
          }}
        />
        <Loading className="swiper-lazy-preloader absolute top-0 left-0" />
      </SwiperSlide>
    )
  })

  return (
    <Wrapper className={className} style={style}>
      <Swiper
        spaceBetween={50}
        navigation
        lazy
        a11y
        preloadImages
        pagination={{ clickable: true }}
        slidesPerView={1}
        {...rest}
      >
        { renderedImages }
      </Swiper>
    </Wrapper>
  );
};

export default ImageCarousel;